import { render, staticRenderFns } from "./PageEmpty.vue?vue&type=template&id=341bac20&scoped=true&"
import script from "./PageEmpty.vue?vue&type=script&lang=js&"
export * from "./PageEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341bac20",
  null
  
)

export default component.exports